import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./UnlockPage.css";

export default function UnlockPage() {
  const navigate = useNavigate();
  const [nickName, setNickName] = useState("");
  const [masterPsw, setMasterPsw] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    if (!nickName || !masterPsw) {
      alert("Please enter nickname and master password.");
      return;
    }

    // get nickname and carry it to chat page - to display name
    navigate("/chat", {
      state: { nickName, masterPsw },
    });
  };
  return (
    <div className="unlock-page">
      <div className="unlock-form">
        <form onSubmit={handleLogin}>
          <div className="unlock-form-row">
            <div className="unlock-form-row-label">NickName:</div>
            <input
              className="unlock-form-row-value"
              type="text"
              value={nickName}
              onChange={(e) => setNickName(e.target.value)}
            ></input>
          </div>
          <div className="unlock-form-row">
            <div className="unlock-form-row-label">Master Password:</div>
            <input
              className="unlock-form-row-value"
              type="text"
              value={masterPsw}
              onChange={(e) => setMasterPsw(e.target.value)}
            ></input>
          </div>
          <div className="unlock-button">
            <button type="submit">Login</button>
          </div>
        </form>
      </div>
    </div>
  );
}
